import { render } from "./GoogleAd1.vue?vue&type=template&id=03c6fd5a"
import script from "./GoogleAd1.vue?vue&type=script&lang=js"
export * from "./GoogleAd1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__